/* eslint-disable max-len */
import { css } from '@emotion/react';

export const filtersStyles = css`
    .filters {
        font-size: var(--body-fontSize);
        font-family: var(--body-fontFamily);
        font-weight: var(--body-fontWeight);

        .header {
            display: flex;
            align-items: center;
            margin: 0 1rem;

            .collapsible-icon {
                color: var(--color-primary);
                cursor: pointer;
            }

            .filters-label {
                color: var(--color-text-primary);
                padding: 0 0.5rem;
            }

            .filters-applied-text {
                color: var(--color-text-primary-lighter);
                padding: 0 0.5rem;
            }

            .collapsible-text {
                color: var(--color-primary);
                cursor: pointer;
            }

            .disabled {
                cursor: not-allowed;
            }

            .clear-filters {
                margin-left: auto;
                color: var(--color-primary);
                cursor: pointer;
            }
        }

        .filters-container {
            display: flex;
            flex-wrap: wrap;
            padding: 1rem 0;

            .search-input {
                .search-input-label {
                    color: var(--color-text-primary);
                }

                .search-input-box {
                    position: relative;
                    margin: 0.5rem 0 0 0;
                }

                .filter-search-input {
                    height: 2.75em;
                    color: var(--color-text-primary);
                    border: 1px solid var(--color-search-input-border);

                    &::placeholder {
                        color: var(--primary-contrastText);
                    }
                }

                .input-left {
                    &::placeholder {
                        padding-left: 1.5rem;
                    }
                }

                .search-icon-left,
                .cancel-icon-left {
                    position: absolute;
                    top: 0.8rem;
                    left: 0.5rem;
                    color: var(--color-primary);
                    pointer-events: none;
                    z-index: 2;
                }

                .search-icon-right,
                .cancel-icon-right {
                    position: absolute;
                    top: 0.8rem;
                    right: 1rem;
                    color: var(--color-primary);
                    pointer-events: none;
                    z-index: 2;
                }

                .cancel-icon-left,
                .cancel-icon-right {
                    pointer-events: auto;
                    cursor: pointer;
                }
            }

            .dropdown-search-container {
                display: flex;
                align-items: center;
            }

            .dropdown-search-input {
                outline: 0;
                width: 100%;
                padding: 0;
                border: 0;

                &::placeholder {
                    color: var(--primary-contrastText);
                }
            }

            .no-option-found {
                color: var(--primary-contrastText);
            }
        }

        .filter-result-text {
            color: var(--color-text-primary);
            margin: 0 1rem;
        }
    }

    .filter-dropdown {
        display: flex;
        margin-top: 0.5rem;

        .dropdown-toggle {
            width: 7rem;
            height: 2.75em;
            padding: 0 0.5rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 1px solid var(--color-dropdown-border);
            color: var(--color-text-primary);

            .dropdown-toggle-icon {
                margin: 0.5rem;
                color: var(--color-primary);
            }

            .placeholder {
                color: var(--color-placeholder);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .dropdown-menu {
            display: none;
        }

        .dropdown-menu.show {
            display: flex;
            flex-direction: column;
            position: absolute;
            z-index: 1000;
            width: 10rem;
            max-height: 10rem;
            overflow-y: auto;
            margin: 0;
            font-size: var(--font-size-regular);
            color: $color-primary;
            font-weight: normal;
            text-align: left;
            list-style: none;
            background-color: var(--color-white);
            background-clip: padding-box;
            border: 1px solid rgba(0, 0, 0, 0.175);
            border-radius: 0.375rem;

            &::-webkit-scrollbar {
                width: 5px;
                height: 5px;
            }

            &::-webkit-scrollbar-track {
                background: var(--color-white);
            }

            &::-webkit-scrollbar-thumb {
                background: var(--color-grey);
                border-radius: 5px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: var(--color-grey);
            }
        }

        .dropdown-item {
            display: flex;
            justify-content: space-between;

            .dropdown-item-label {
                cursor: pointer;
            }
        }

        .multi-select {
            padding: 0.5rem;

            .dropdown-item {
                margin: 0 0.5rem;
            }
        }

        .single-select {
            padding: 0;
            .dropdown-item {
                cursor: pointer;
                padding: 0.2rem 1rem;
                &:hover {
                    background-color: var(--color-primary);
                }
            }
        }
    }

    .no-data-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .selected-filters {
        margin: 0 1rem;
        display: flex;
        flex-direction: column;

        .filter-by {
            margin-bottom: 0.5rem;
        }

        .options {
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            margin-bottom: 0.5rem;
        }

        .option {
            padding: 0.2rem 1rem;
            border: 1px solid var(--color-border-medium);
            border-radius: 1rem;
            display: flex;
            align-items: center;

            &:nth-of-type(1) {
                margin-left: 0;
            }
        }

        .icon-cancel {
            margin-left: 0.5rem;
            color: var(--color-primary);
            cursor: pointer;
            height: 1rem;
        }
    }

    .date-filter-container {
        display: flex;
        align-items: flex-start;
    }

    .react-datepicker-wrapper {
        width: auto;
        width: auto;
        display: flex;
        align-items: center;

        .react-datepicker {
            .year-select {
                margin-right: 0.5rem;
            }
        }
    }

    .react-datepicker-popper {
        z-index: 1000;
    }

    .start-date-container,
    .end-date-container {
        margin-right: 1rem;
    }

    .custom-react-date-picker-select {
        .custom-react-date-picker-select-option {
            cursor: pointer;
        }

        &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }

        &::-webkit-scrollbar-track {
            background: var(--color-white);
        }

        &::-webkit-scrollbar-thumb {
            background: var(--color-grey);
            border-radius: 5px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: var(--color-grey);
        }
    }

    .custom-date-picker {
        display: flex;
        flex-direction: column;

        .custom-date-picker-input {
            display: flex;
            align-items: center;
            border: 1px solid var(--color-border);
            width: 11rem;
            border-radius: 5px;
            padding: 0.5rem 0.5rem;
            margin-top: 0.5rem;
            color: var(--color-text-primary);

            .custom-date-picker-icon-right {
                margin-left: auto;
            }

            .custom-date-picker-icon-left {
                margin-right: auto;
            }

            .custom-date-picker-image {
                width: 1rem;
                height: 1rem;
            }
        }

        .custom-date-picker-input-error {
            border: 1px solid var(--color-error-border);
        }

        .custom-date-picker-error-message {
            display: inline-block;
            color: var(--color-error-text);
            width: 11rem;
        }
    }
`;
